import React, { Fragment, useState } from "react";

// UI Components
import Select from "react-select";
import {
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { log } from "../utils/logger";
import { toastr } from "react-redux-toastr";
import formatFoldersForSelect from "../utils/formatFoldersForSelect";

// CONFIGS
const styles = {
  option: (styles, { data }) => ({
    ...styles,
    paddingLeft: `${10 + data.nest * 20}px`,
  }),
};

/**
 * The Create Campaign Folder modal and associated button handlers
 * @param {boolean}   showModal             Whether the modal is open
 * @param {array}     folders               MySQL.folders objects
 * @param {object}    parentFolder          MySQL.folders object for the selected parent folder
 * @param {function}  toggleModal           Toggle the Modal
 * @param {function}  createCampaignFolder  Redux linked function to execute the order
 * @param {function}  onParentFolderChanged
 */
const CreateCampaignFolderModal = ({
  showModal = false,
  folders,
  parentFolder,
  toggleModal,
  createCampaignFolder,
  onParentFolderChanged,
}) => {
  // Internal state
  const [folderName, setFolderName] = useState("");

  // Convert flat array to a nested tree of parent and children folders
  const formattedOptions = formatFoldersForSelect(folders);

  // Inputs
  const onFolderName = ({ target }) => {
    // log("Updating folder name to", target.value);
    setFolderName(target.value);
  };

  // Managed by parent
  const onParentIdChanged = (newParentFolder) => {
    log("Updating parentId", parentFolder, newParentFolder);
    onParentFolderChanged(newParentFolder);
  };

  const onSubmit = () => {
    if (!folderName || folderName.length < 3) {
      return toastr.warning(
        "Invalid name",
        "Please choose a folder name with at least 3 characters"
      );
    }
    if (/[^\w\d\s/]/.test(folderName)) {
      return toastr.warning(
        "Invalid name",
        "Please choose a folder name only letters, numbers, dashes, and forward slashes"
      );
    }

    const parent = parentFolder.value;

    createCampaignFolder({ folderName, parent })
      .then(() => {
        toastr.success("Folder created");
        toggleModal();
      })
      .catch((err) => toastr.error(err));
  };

  return (
    <Fragment>
      {/* ADD FOLDER MODAL */}
      <Modal isOpen={showModal} toggle={toggleModal}>
        <ModalHeader toggle={() => toggleModal()}>Modal title</ModalHeader>

        <ModalBody>
          <InputGroup className="mb-3">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>Folder Name: </InputGroupText>
            </InputGroupAddon>

            <Input onChange={onFolderName} placeholder="Enter folder name" />
          </InputGroup>

          <p className="mb-0">Put under folder:</p>

          <Select
            value={parentFolder}
            options={formattedOptions}
            onChange={onParentIdChanged}
            styles={styles}
          />
        </ModalBody>

        <ModalFooter className="d-flex justify-content-between">
          <Button color="secondary" onClick={() => toggleModal()}>
            Cancel
          </Button>

          <Button color="primary" onClick={onSubmit}>
            Save Folder
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default CreateCampaignFolderModal;
